<template lang="pug">
.sell-record-history.d-flex.flex-fill.scrollable.px-2.py-2
  .transaction-timeline.h-100.w-custom-40.py-4.pl-4.pr-2.sticky-top
    .text-title.bold
      | ประวัติการทำรายการ
    //- .text-medium
    //-   | {{ notificationsIds }}
    .events.flex-fill.scrollable.mt-3
      template(v-for='(item, index) in logs')
        button.transparent-button.no-scaling.w-100.px-2.py-3(:key='index')
          .d-flex.justify-content-between
            .text-left
              //- .text-medium
              //-   | {{ item }}
              .text-17
                template(v-if='item.user && item.user.name')
                  | {{ item.user.name }}
                template(v-else)
                  | {{ `<ผู้ใช้ #${item.user_id}>` }}
              .text-19.text-bold.mt-1
                | {{ LOG_MESSAGES[item.type_id] }}
            .text-right
              template(v-if='item.updated_at')
                .text-small {{ $moment(item.updated_at).format('DD/MM/YY') }}
        hr.m-0

  .messages.h-100.w-custom-60.p-4
    .text-title.bold
      | ข้อความ
    .message-box.shadow.mt-3
      //- show error & retry button
      template(v-if='messages === null || messages === undefined')
        LoadingError(
          title='เกิดปัญหาในการโหลดข้อความ'
          @reload='loadData'
        )
      //- show message list
      template(v-else)
        #messages-list.scrollable
          template(v-for='(entry, index) in messages')
            div.d-flex.px-3.py-3.w-100(:key='index')
              template(v-if='entry.user && entry.user.profile_image_path')
                img.img-48.rounded-circle(
                  :src='entry.user.profile_image_path'
                )
              template(v-else)
                img.img-48.rounded-circle(style='background: #ebebeb;')

              .d-flex.flex-column.ml-3(style='overflow: auto;')
                //- .text-medium
                //-   | {{ entry }}
                .text-medium(style='font-size: 15px')
                  template(v-if='entry.user && entry.user.name')
                    | {{ entry.user.name }}
                  template(v-else)
                    | {{ `<ผู้ใช้ #${entry.user_id}>` }}
                .message-body.text-17.mt-1
                  | {{ entry.message }}
                .text-small.text-right
                  | {{ $moment(entry.date).format('DD/MM/YY') }}

      .new-message
        hr.mb-0(style='color: #B0C9C7;')
        form.bottom-bar.d-flex.px-3.py-2.m-0(@submit.prevent='submitMessage')
          InputWithIconSlot.flex-fill(
            type='text' placeholder='พิมพ์ข้อความ' width='100%'
            v-model='newMessage'
          )
            i.fa.fa-comments
          button.btn.btn.btn-primary.px-3.ml-2(
            type='submit'
            :disabled='!newMessage'
          )
            | ส่งข้อความ

</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    orderId: {
      default: null,
    },
    value: {
      default: null,
    },
  },
  data: () => ({
    logs: [
      // {
      //   username: 'username',
      //   eventName: 'เปิดบิลรายการขาย',
      //   date: '2020-01-11',
      // },
      // {
      //   username: 'username',
      //   eventName: 'อนุมติรายการขาย',
      //   date: '2020-01-13',
      // },
    ],
    LOG_MESSAGES: {
      1: 'เปิดบิลรายการขาย', // created
      2: 'อนุมัติรายการขาย', // approved
      3: 'ไม่อนุมัติรายการขาย', // rejected
      4: 'แก้ไขรายการขาย', // edited
      5: 'ส่งต่อให้ผู้ตรวจสอบออเดอร์/แอดมิน', // send to admin
      6: 'ส่งกลับให้ CS', // send to CS
    },

    newMessage: '',
    messages: [
      // {
      //   userImg: 'http://placekitten.com/72/72',
      //   username: 'username',
      //   message: 'รบกวนตรวจสอบความถูกต้องบิลรายการขายเลขที่ 5678 และอนุมัติได้เลย',
      //   date: '2020-01-11',
      // },
    ],
  }),
  // computed: {
  //   // NOTIFICATIONS
  //   notificationsIds() {
  //     const allNoti = this.orderNotifications();
  //     if (allNoti && allNoti[this.orderId]) {
  //       return allNoti[this.orderId].notifications;
  //     }
  //     return [];
  //   },
  // },
  watch: {
    orderId() {
      this.loadData();
    },
  },
  async mounted() {
    await this.$api.notification.list();

    this.loadData();

    const allNoti = this.orderNotifications();
    let NOTI_IDS = [];
    if (allNoti && allNoti[this.orderId]) {
      NOTI_IDS = allNoti[this.orderId].notifications;
    }
    // alert(NOTI_IDS);

    for (let i = 0; i < NOTI_IDS.length; i += 1) {
      const id = NOTI_IDS[i];
      try {
        // eslint-disable-next-line
        const res = await this.$api.notification.markAsRead(id, this.orderId);

        if (res.status === 201) {
          // if success, tell the root element to hide the notification dot
          this.$emit('input', false);
        }

        console.log(res);
      } catch (e) {
        console.log(e);
      }
    }
    // console.log(this.orderId);
  },
  methods: {
    ...mapGetters({
      orderNotifications: 'orderNotifications',
    }),
    async loadData() {
      this.isLoading = true;

      try {
        // const res = await this.$api.history.chatMessages(this.orderId);
        const res = await this.$api.order.getWithId(this.orderId);
        if (res.status === 200) {
          this.messages = res.data.messages;
          this.logs = res.data.logs;

          setTimeout(() => {
            const element = document.getElementById('messages-list');
            element.scrollTop = element.scrollHeight;
          }, 20);
        } else {
          console.log(res);
          this.messages = null;
        }
      } catch (e) {
        console.log(e);
        this.messages = null;
      }

      this.isLoading = false;
    },

    async submitMessage() {
      // alert('Message submit');
      try {
        // const res = await this.$api.history.submitChatMessages(this.orderId, this.newMessage);
        const res = await this.$api.history.submitChatMessages(this.orderId, this.newMessage);
        if (res.status === 201) { // success
          const NEW_MSG = res.data;
          this.messages.push(NEW_MSG);
          this.newMessage = '';

          this.loadData();
        }
      } catch (e) {
        alert(`เกิดปัญหาในการส่งข้อความ \n${e}`);
      }
    },
  },
};
</script>

<style lang="scss">
.sell-record-history {
  .transaction-timeline {
    display: flex;
    flex-direction: column;
  }
  .messages {
    display: flex;
    flex-direction: column;
    .message-box {
      display: flex;
      flex-direction: column;
      width: 100%;
      flex: 1;
      // background: rgba(#DCE4EE, 0.25);
      background: #fafafa;
      // box-shadow: 0px 20px 20px rgba(#000, 0.5);
      #messages-list {
        flex: 1;
        max-height: -webkit-fill-available;
        .message-body {
          background: #EDF1F6;
          padding: 12px 16px;
          border-radius: 8px;

          overflow-wrap: break-word;
        }
      }
      .bottom-bar {
        background: #fff;
      }
    }
  }
}
</style>
